import { MdFamilyRestroom, MdWork } from 'react-icons/md';
import { t } from '../../utils/i18n';

export default function BenefitsSection() {
  return (
    <section className="landing-section landing-section--muted">
      <div className="landing-container">
        <header className="text-center mb-10 sm:mb-12">
          <h2 className="landing-section-title">
            {t('landing.benefits.title')}
          </h2>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          <BenefitCard
            title={t('landing.benefits.parents.title')}
            icon={MdFamilyRestroom}
            items={['item1', 'item2', 'item3']}
            prefix="landing.benefits.parents"
          />
          <BenefitCard
            title={t('landing.benefits.sitters.title')}
            icon={MdWork}
            items={['item1', 'item2', 'item3']}
            prefix="landing.benefits.sitters"
          />
        </div>
      </div>
    </section>
  );
}

function BenefitCard({ title, icon: Icon, items, prefix }) {
  return (
    <article className="landing-benefit-card rounded-2xl p-6 sm:p-7">
      <div className="flex items-center gap-3 mb-5">
        <span className="landing-benefit-icon w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0">
          <Icon className="text-lg text-primary-600 dark:text-primary-400" aria-hidden="true" />
        </span>
        <h3 className="text-lg font-semibold text-[var(--color-text)]">{title}</h3>
      </div>
      <ul className="space-y-3">
        {items.map((key) => (
          <li
            key={key}
            className="text-[15px] text-[var(--color-text-muted)] leading-relaxed pl-4 border-l-2 border-[var(--color-border)]"
          >
            {t(`${prefix}.${key}`)}
          </li>
        ))}
      </ul>
    </article>
  );
}
